import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Stack, styled, Typography } from '@mui/material';

import AltiboxLogo from '@assets/images/AltiboxLogo.svg?react';
import env from '@config/runtimeConfig';

const StyledLogo = styled(AltiboxLogo)`
  padding: ${({ theme }) => theme.spacing(2)};
  width: 120px;

  * {
    fill: ${({ theme }) => theme.palette.text.primary};
  }
`;

const NoAccessThemes = ['cat', 'dog', 'gandalf'] as const;
type NoAccessTheme = (typeof NoAccessThemes)[number];

const noAccessEmojiMap: Record<NoAccessTheme, string> = {
  cat: '🙀',
  dog: '🐶',
  gandalf: '🧙‍♂️',
};

export const NoAccess: FC = () => {
  const { t } = useTranslation();

  const [noAccessTheme] = useState(
    () => NoAccessThemes[Math.floor(Math.random() * NoAccessThemes.length)]
  );

  return (
    <Box alignItems='center' display='flex' flexDirection='column' minHeight={1}>
      <Stack
        alignItems='center'
        flex={1}
        justifyContent='center'
        m='auto'
        maxWidth={640}
        p={2}
        spacing={2}
        textAlign='center'
        width={1}
      >
        <Typography fontSize='5rem'>{noAccessEmojiMap[noAccessTheme]}</Typography>

        <Box>
          <Typography component='p' gutterBottom variant='h2'>
            {t('noAccess', { context: noAccessTheme })}
          </Typography>

          <Typography gutterBottom>
            <Trans
              components={{ strong: <strong /> }}
              i18nKey='noAccess.desc1'
              values={{
                context: noAccessTheme,
                appName: t('noAccess.appName', {
                  context: env,
                  env: env.toUpperCase(),
                }),
              }}
            />
          </Typography>

          <Typography gutterBottom>{t('noAccess.desc2', { context: noAccessTheme })}</Typography>
        </Box>
      </Stack>
      <StyledLogo />
    </Box>
  );
};
